import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
import _imports_0 from '../assets/arrow-right.png';
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 0,
    class: "docsPanel"
};
const _hoisted_3 = ["href"];
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useMortgage } from '@/composables/useMortgage';
import { useCredit } from '@/composables/useCredit';
import { useDocuments } from '@/composables/useDocuments';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import WellPanel from './elements/WellPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MortgagePage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getMortgage, deleteMortgageAccount, getMortgageInfo, getInterestRateType, calculateMonthsRemaining, calculateDateProgressPercentage } = useMortgage();
        const { getCreditInfo } = useCredit();
        const { getDocumentsByHubId } = useDocuments();
        const wellData = ref([]);
        function onLoad() {
            const policyId = route.params.id;
            getCustomer();
            getMortgage(policyId, () => {
                const policy = state.policy;
                const address = policy.address ?
                    [policy.address.line1, policy.address.line2, policy.address.line3, policy.address.town, policy.address.postCode].filter(Boolean).join(', ') :
                    '';
                wellData.value = [
                    { order: 1, label: 'Sole or joint', value: policy.account.jointStatus === 0 ? 'Sole' : 'Joint' },
                    { order: 2, label: 'Account number', value: policy.account.reference },
                    { order: 3, label: 'Address', value: address },
                    { order: 4, label: 'Current balance', value: state.formatter.format(policy.account.balance.amount) },
                    { order: 5, label: 'Monthly repayment', value: state.formatter.format(policy.monthlyRepaymentAmount) },
                    { order: 6, label: 'Original term', value: policy.account.termMonths / 12 + ' years' },
                    { order: 7, label: 'Type', value: getInterestRateType(policy.interestRateType) },
                    { order: 8, label: 'Deal rate', value: policy.dealRate + '%' },
                    { order: 9, label: `Promotion expiry | in ${calculateMonthsRemaining(policy.dealEndDate)} months`, value: state.dateFormatPretty.format(new Date(policy.dealEndDate)), progress: calculateDateProgressPercentage(policy.account.creditCreateDate, policy.dealEndDate) },
                ];
                getDocumentsByHubId(policy.id);
            });
        }
        function deleteAccount() {
            deleteMortgageAccount(route.params.id, () => {
                getCreditInfo(null, true);
                getMortgageInfo(null, true);
                router.push('/money');
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    del: true,
                    onDelete: deleteAccount,
                    title: 'Mortgage',
                    edit: '/Mortgages/Edit/' + _unref(route).params.id
                }, null, 8, ["edit"]),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).policy
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).policy)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createVNode(WellPanel, {
                                    title: _unref(state).policy.account.provider.name,
                                    subTitle: "Provider",
                                    avatarLetter: _unref(state).policy.account.provider.name.charAt(0),
                                    data: wellData.value
                                }, null, 8, ["title", "avatarLetter", "data"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                (_unref(state).documents && _unref(state).documents.length > 0)
                    ? (_openBlock(), _createBlock(DrawerPanel, {
                        key: 0,
                        bottom: "-18px",
                        openHeight: "450px",
                        title: "Saved documents",
                        backgroundColor: "white",
                        openBackgroundColor: "white"
                    }, {
                        default: _withCtx(() => [
                            (_unref(state).documents)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).documents, (d) => {
                                        return (_openBlock(), _createElementBlock("a", {
                                            key: d.id,
                                            href: d.url
                                        }, [
                                            _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { cols: "1" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, {
                                                                class: "docIcon",
                                                                icon: "mdi-file-document-outline"
                                                            })
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { class: "docCol" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(d.name), 1),
                                                            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                                                            _cache[1] || (_cache[1] = _createElementVNode("span", null, null, -1))
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, {
                                                        cols: "1",
                                                        class: "arrowCol"
                                                    }, {
                                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                            _createElementVNode("img", {
                                                                class: "arrow",
                                                                src: _imports_0
                                                            }, null, -1)
                                                        ])),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 2
                                            }, 1024)
                                        ], 8, _hoisted_3));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
